import HTTPError from '@error/HTTPError';
import getActionCreators from '@redux/getActionCreators';
import { Dispatch } from 'redux';

type TRequestParams = {
  reduxActionName: string;
  controllerFunc: (...args: any[]) => any;
  dispatch: Dispatch;
  params?: any;
  isSingleRequest?: boolean;
};

export const request = async ({
  reduxActionName,
  controllerFunc,
  dispatch,
  params,
  isSingleRequest,
}: TRequestParams): Promise<any> => {
  const { requestReady: globalRequestReady, requestStart: globalRequestStart } = getActionCreators('global');
  const { setParamsForRequest, requestReady, requestStart, requestSuccess, requestFail } = getActionCreators(reduxActionName);

  dispatch(setParamsForRequest(params));
  dispatch(requestStart());

  if (!isSingleRequest) {
    dispatch(globalRequestStart());
  }

  try {
    const response = await controllerFunc(params);

    if (!response) {
      throw new HTTPError('GENERAL_NETWORK_ERROR', `${reduxActionName} REQUEST was failed`);
    }

    if (response && response.errorCode) {
      throw new HTTPError(response.errorCode, `${reduxActionName} REQUEST was failed`);
    }

    const resData = await response;

    if (resData.error) {
      throw resData.error;
    }

    dispatch(requestSuccess({ data: resData }));
  } catch (error) {
    let errorMessage = error.message;

    if (error instanceof HTTPError) {
      errorMessage = error.codeToErrorMessage;
    }

    dispatch(requestFail({ error, errorMessage }));
  } finally {
    dispatch(requestReady());
    if (!isSingleRequest) {
      dispatch(globalRequestReady());
    }
  }
};
